module.exports = __webpack_public_path__ + "img/logo-dark.10206a3d.png";